import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class NwKeywordTableRowClassComponent extends Component {
  @tracked isOptimizeModalVisible = false;
  INSTRUCTIONS =
    'Crawl page to analyse headlines, titles and suggest practical improvements to the page and content enhancement';
  @tracked
  agentPrompt = `Suggest optimizations for content on the page ${this.urlArg.url} for targeting the keyword "${this.keywordArg.query}" ${this.INSTRUCTIONS}`;

  @action
  changeOptimizeModalState(state) {
    this.isOptimizeModalVisible = state;
  }

  @action
  closeOptimizeModal() {
    this.isOptimizeModalVisible = false;
  }

  get keywordArg() {
    return this.args?.keyword;
  }

  get urlArg() {
    return this.args?.url;
  }

  @action
  encodeUrlURI(prompt) {
    return `https://agent.nightwatch.io/?run=${encodeURIComponent(prompt)}`;
  }
}
